import styled, { keyframes } from 'styled-components';
import { pallette } from '../../config/pallette';

export const FeedbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-weight: bold;
  position: relative;
  margin-left: 50px;
`;

export const FeedbackButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const FeedbackButton = styled.button`
  min-width: 34px;
  min-height: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: ${pallette.lightGray};
  }
`;

export const Tooltip = styled.div`
  position: absolute;
  top: 50px;
  left: ${(props) => (props.show === 'good' ? "-35px" : "5px")};
  transform: translateY(-50%);
  background-color: ${pallette.main};
  color: ${pallette.white};
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  visibility: ${(props) => (props.show ? "visible" : "hidden")};
  opacity: ${(props) => (props.show ? "1" : "0")};
  transition: opacity 0.2s ease-in-out;
  z-index: 10;
  cursor: pointer;

  &::before {
    content: "";
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid ${pallette.main};
  }
`;

export const PositiveFeedbackMessage = styled.p`
  font-weight: normal;
  font-size: 14px;
`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
  width: 18px;
  height: 18px;
  border: 2px solid ${pallette.main};
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
  margin-bottom: 6px;
`;

export const FeedbackTextContainer = styled.div`
  border: 1px solid ${pallette.lightGray};
  padding: 10px;
  margin: 15px 0;
  width: 400px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;

  @media (max-width: 500px) {
    min-width: auto;
    width: calc(100% - 20px);
  }
`;

export const FeedbackTextInstruction = styled.span`
  font-size: 14px;
  font-weight: normal;
`;

export const FeedbackTextInput = styled.textarea`
  font-size: 14px;
  font-weight: normal;
  border: none;
  resize: none;
  width: 100%;

  &:focus {
    outline: none;
  }
`;

export const FeedbackSendContainer = styled.div`
  align-self: flex-end;
`;

export const FeedbackTextLengthIndicator = styled.span`
  font-weight: normal;
  color: ${pallette.gray};
  margin-right: 15px;
`;

export const FeedbackSendButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
`;
